import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link, withRouter } from 'react-router-dom';
import * as apiConfig from "../../api/config";
import { Nav, NavItem, NavLink } from 'reactstrap';
import UserAvatar from 'react-user-avatar';
import { checkLogin } from '../../redux/actions/authActions';
import $ from 'jquery';

const sections = [
    
];

function NavMenu({
    navItems,
    hideProfileLink,
    hideAboutLink,
    user,
    checkLogin,
    history,
    ...props
}){

    useEffect(() => {
        if (!user || !user.id) {
            checkLogin().catch(() => {
                history.push("/login");
            });
        }
    }, [])

    function getNavItems() {
        var nav = sections
        if (navItems) {
            nav = nav.concat(navItems.sections); 
        }
        return nav;
    }

    $('.nav-item>a').on('click', function () {
        $('.navbar-collapse').collapse('hide');
    });

    return (

        <div className="nav-menu-control">
            {
                !hideProfileLink &&
                <React.Fragment>
                    <Link to="/user/profile" className="nav-user">
                        {user.avatarAvailable ?
                            <UserAvatar className="nav-user-avatar" size="40" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                            :
                            <div className="nav-user-avatar user-avatar-default"><span className="fas fa-user" /></div>
                        }
                        <span className="nav-user-name" >{user ? `${user.firstName} ${user.surname}` : ""}</span>
                    </Link>
                    <hr />
                </React.Fragment>
            }
                
            {
                getNavItems().map((section, index) => (
                        section.items &&
                        <React.Fragment key={index}>
                            {section.showTitle && <div className="nav-title">{section.name}</div>}
                            <ul className="nav flex-column"> {
                                section.items.map((item, index) => (

                                    <li key={index} role="presentation" className="nav-item">
                                        {
                                            item.path ?
                                                (
                                                    item.external && item.external === true ?
                                                        <a className="nav-link" href={item.path}><span className={item.icon}></span> {item.text}</a>
                                                        :
                                                        <Link to={item.path} className={
                                                            props.location.pathname === item.path && !item.disableHighlight
                                                                ? 'nav-link active'
                                                                : 'nav-link'}>

                                                            {item.avatar && item.avatar.available &&
                                                                <UserAvatar className="nav-avatar" size="25" name={item.text} src={`${apiConfig.API_URL}${item.avatar.type}/avatar/${item.avatar.id}.png`} />
                                                            }
                                                            {item.avatar && !item.avatar.available &&
                                                                <div className="nav-avatar nav-avatar-default"><span className="fas fa-users" /></div>
                                                            }
                                                            {!item.avatar &&
                                                                <div className={item.icon}></div>
                                                            }
                                                            <div className="nav-text">{item.text}</div>
                                                        </Link>
                                                )
                                                :
                                                <a className="nav-link" href="#" onClick={item.func}>
                                                    {item.avatar && item.avatar.available &&
                                                        <UserAvatar className="nav-avatar" size="25" name={item.text} src={`${apiConfig.API_URL}${item.avatar.type}/avatar/${item.avatar.id}.png`} />
                                                    }
                                                    {item.avatar && !item.avatar.available &&
                                                        <div className="nav-avatar nav-avatar-default"><span className="fas fa-users" /></div>
                                                    }
                                                    {!item.avatar &&
                                                        <span className={item.icon}></span>
                                                    }

                                                    <div className="nav-text">{item.text}</div>
                                                </a>
                                        }
                                    </li>

                                ))
                            }
                                < hr />
                            </ul>
                        </React.Fragment>
                ))}

                {!hideAboutLink &&
                    <ul className="nav flex-column">
                        <li role="presentation" className="nav-item">
                            <Link to="/about" className={props.location.pathname === "/about" ? 'nav-link active' : 'nav-link'}>
                                <div className="fas fa-info-circle"></div>
                                <div className="nav-text">About JustGoRide</div>
                            </Link>
                        </li>
                        < hr />
                    </ul>
                }
                
                { navItems.avatarLinks &&
                    <React.Fragment>
                        <div className="nav-title">{navItems.avatarLinks.name}</div>
                        <div className="avatar-links">
                            <ul className="">
                                {navItems.avatarLinks.links.map((link, index) => (
                                    <li key={1000 - index} role="presentation" className="nav-item avatar-link">
                                        <Link to={link.path}>
                                            {link.avatar ?
                                                <UserAvatar className={link.avatarClass} size="50" name={link.label} src={link.avatar} title={link.label}/>
                                                :
                                                <div className={link.avatarClass} title={link.label}><span className={link.icon} /></div>}
                                            <div className="avatar-label" title={link.label}>{link.label}</div> 
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </React.Fragment>
                }
               
        </div>
    );
}

NavMenu.propTypes =
    {
        navItems: PropTypes.object.isRequired,
        user: PropTypes.object,
        checkLogin: PropTypes.func.isRequired
    }


function mapStateToProps(state) {
    return {
        navItems: state.navItems,
        user: state.user
    };
}

const mapDispatchToProps = {
    checkLogin
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavMenu)); 
   

/*
{
        name: 'Actions',
        items: [
            {
                path: '/routes/explore',
                text: 'Explore',
                icon: 'fa-search',
                disableHighlight: true
            },
            {
                path: '/routes/create',
                text: 'Create',
                icon: 'fa-pencil-alt'
            },
            {
                path: '/routes/upload',
                text: 'Upload',
                icon: 'fa-file-upload'
            }

        ]
    }
 */




// WEBPACK FOOTER //
// ./src/components/common/NavMenu.js